/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts"
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_OrderNote_OrderNote__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/OrderNote/OrderNote */ "./resources/scripts/components/OrderNote/OrderNote.ts");
/* harmony import */ var _components_CollectionProductMix_edition_product_mix__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/CollectionProductMix/edition-product-mix */ "./resources/scripts/components/CollectionProductMix/edition-product-mix.ts");
/* harmony import */ var _components_CollectionProductMix_mix_cart_edit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @components/CollectionProductMix/mix-cart-edit */ "./resources/scripts/components/CollectionProductMix/mix-cart-edit.ts");

// Theme scripts can be evaluated more than once (e.g. section rehydration / PJAX-like flows).
// Guard custom element registration to avoid "NotSupportedError: already defined" which can break all JS.
if (!customElements.get("note-wrapper")) {
  customElements.define("note-wrapper", _components_OrderNote_OrderNote__WEBPACK_IMPORTED_MODULE_0__["default"]);
}


if (!customElements.get("edition-product-mix")) {
  customElements.define("edition-product-mix", _components_CollectionProductMix_edition_product_mix__WEBPACK_IMPORTED_MODULE_1__["default"]);
}
(0,_components_CollectionProductMix_mix_cart_edit__WEBPACK_IMPORTED_MODULE_2__["default"])();

/***/ },

/***/ "./resources/scripts/components/CollectionProductMix/edition-product-mix.ts"
/*!**********************************************************************************!*\
  !*** ./resources/scripts/components/CollectionProductMix/edition-product-mix.ts ***!
  \**********************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionProductMix)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EditionProductMix = /*#__PURE__*/function (_HTMLElement) {
  function EditionProductMix() {
    var _this;
    _classCallCheck(this, EditionProductMix);
    _this = _callSuper(this, EditionProductMix);
    _defineProperty(_this, "items", new Map());
    _defineProperty(_this, "initialized", false);
    _defineProperty(_this, "editRemoveKeys", []);
    _defineProperty(_this, "bar", null);
    _defineProperty(_this, "progressEl", null);
    _defineProperty(_this, "progressLabelEl", null);
    _defineProperty(_this, "toastEl", null);
    // Support multiple instances of UI (desktop sidebar + mobile bar + mobile drawer)
    _defineProperty(_this, "bars", []);
    _defineProperty(_this, "progressEls", []);
    _defineProperty(_this, "progressDotEls", []);
    _defineProperty(_this, "progressLabelEls", []);
    _defineProperty(_this, "toastEls", []);
    _defineProperty(_this, "submitBtns", []);
    _defineProperty(_this, "validationEls", []);
    _defineProperty(_this, "listHosts", []);
    _defineProperty(_this, "totalPriceEls", []);
    _defineProperty(_this, "boxImageEls", []);
    _defineProperty(_this, "boxImageLoaded", false);
    // Mobile drawer (optional)
    _defineProperty(_this, "mobileDrawer", null);
    _defineProperty(_this, "mobileOverlay", null);
    _defineProperty(_this, "mobileSheet", null);
    _defineProperty(_this, "mobileBar", null);
    _defineProperty(_this, "mobileOpenBtn", null);
    _defineProperty(_this, "submitBtn", null);
    _defineProperty(_this, "validationEl", null);
    // Sidebar list container (optional)
    _defineProperty(_this, "boxListEl", null);
    // Gift note modal
    _defineProperty(_this, "noteEnabled", false);
    _defineProperty(_this, "noteVariantId", null);
    _defineProperty(_this, "noteModal", null);
    _defineProperty(_this, "noteTextarea", null);
    _defineProperty(_this, "noteError", null);
    _defineProperty(_this, "pendingSubmit", false);
    // Note preview modal
    _defineProperty(_this, "notePreviewModal", null);
    // Post-submit modal (optional)
    _defineProperty(_this, "postModal", null);
    _defineProperty(_this, "postCheckoutBtn", null);
    _defineProperty(_this, "minTotal", 4);
    _defineProperty(_this, "maxTotal", 8);
    _defineProperty(_this, "lastIsValid", false);
    _defineProperty(_this, "parentVariantId4", null);
    _defineProperty(_this, "parentVariantId8", null);
    _defineProperty(_this, "currencyCode", "DKK");
    _defineProperty(_this, "currencyLocale", "da-DK");
    _defineProperty(_this, "copy", {
      submitBase: "Add box to cart",
      submitReady: "Add box to cart",
      submitNeedMoreOne: "Choose {{ count }} more cookie",
      submitNeedMoreOther: "Choose {{ count }} more cookies",
      toastCartFirst: "Add your box to cart first",
      toastNewBox: "Start en ny æske",
      toastEditBox: "Rediger din æske",
      toastMaxCookies: "Maks {{ max }} cookies",
      sidebarEmptyHint: "Vælg {{ min }}-{{ max }} cookies for at lave din kasse.",
      sidebarRemove: "Fjern",
      sidebarPriceLabel: "Pris",
      ariaIncrease: "Increase",
      ariaDecrease: "Decrease"
    });
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleGlobalClicks = _this.handleGlobalClicks.bind(_this);
    return _this;
  }
  _inherits(EditionProductMix, _HTMLElement);
  return _createClass(EditionProductMix, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$listHosts;
      if (this.initialized) return;
      this.initialized = true;
      this.copy = this.readCopy();
      this.parentVariantId4 = this.readParentVariantIdByAttr("data-mix-parent-variant-id-4");
      this.parentVariantId8 = this.readParentVariantIdByAttr("data-mix-parent-variant-id-8");
      this.noteEnabled = this.readNoteEnabled();
      this.noteVariantId = this.readNoteVariantId();
      this.detectCurrency();
      // Sticky bar
      this.bar = this.querySelector("[data-mix-bar]");
      this.progressEl = this.querySelector("[data-mix-progress]");
      this.progressLabelEl = this.querySelector("[data-mix-progress-label]");
      this.toastEl = this.querySelector("[data-mix-toast]");
      // Multi-instance UI
      this.bars = Array.from(this.querySelectorAll("[data-mix-bar]"));
      this.progressEls = Array.from(this.querySelectorAll("[data-mix-progress]"));
      this.progressDotEls = Array.from(this.querySelectorAll("[data-mix-progress-dot]"));
      this.progressLabelEls = Array.from(this.querySelectorAll("[data-mix-progress-label]"));
      this.toastEls = Array.from(this.querySelectorAll("[data-mix-toast]"));
      this.submitBtns = Array.from(this.querySelectorAll("[data-mix-submit]"));
      this.validationEls = Array.from(this.querySelectorAll("[data-mix-validation]"));
      this.totalPriceEls = Array.from(this.querySelectorAll("[data-mix-total-price]"));
      this.boxImageEls = Array.from(this.querySelectorAll("img[data-mix-box-image]"));
      this.submitBtn = this.querySelector("[data-mix-submit]");
      this.validationEl = this.querySelector("[data-mix-validation]");
      // Sidebar list container
      this.boxListEl = this.querySelector("#cookie-box-mix");
      // Render targets for the sidebar list (desktop + mobile)
      this.listHosts = [];
      if (this.boxListEl) this.listHosts.push(this.boxListEl);
      (_this$listHosts = this.listHosts).push.apply(_this$listHosts, _toConsumableArray(Array.from(this.querySelectorAll("[data-mix-mobile-list]"))));
      // Mobile drawer elements (optional)
      this.mobileDrawer = this.querySelector("[data-mix-mobile-drawer]");
      this.mobileOverlay = this.querySelector("[data-mix-mobile-overlay]");
      this.mobileSheet = this.querySelector("[data-mix-mobile-sheet]");
      this.mobileBar = this.querySelector("[data-mix-mobile-bar]");
      this.mobileOpenBtn = this.querySelector("[data-mix-mobile-open]");
      // Note modal elements (optional)
      this.noteModal = this.querySelector("[data-mix-note-modal]");
      this.noteTextarea = this.querySelector("[data-mix-note-textarea]");
      this.noteError = this.querySelector("[data-mix-note-error]");
      // Note preview modal
      this.notePreviewModal = this.querySelector("[data-note-preview-modal]");
      // Post-submit modal elements (optional)
      this.postModal = this.querySelector("[data-mix-post-modal]");
      this.postCheckoutBtn = this.querySelector("[data-mix-post-checkout]");
      this.addEventListener("click", this.handleClick);
      document.addEventListener("click", this.handleGlobalClicks, true);
      this.restoreEditFromSession();
      this.updateUI();
      // Ensure the mobile drawer knows how tall the fixed bottom bar is.
      this.updateMobileBarOffset();
      // Best-effort: load the "box" image (same variant that is added to cart)
      void this.loadBoxImage();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      document.removeEventListener("click", this.handleGlobalClicks, true);
      this.initialized = false;
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var target = event.target;
      if (!target) return;
      // Mobile drawer controls (if present)
      if (target.closest("[data-mix-mobile-open]")) {
        this.openMobileDrawer();
        return;
      }
      if (target.closest("[data-mix-mobile-close]") || target.closest("[data-mix-mobile-overlay]")) {
        this.closeMobileDrawer();
        return;
      }
      // Clear selection (support multiple clear buttons)
      if (target.closest("[data-mix-clear]")) {
        this.items.clear();
        this.resetAllCards();
        this.updateUI();
        return;
      }
      // Post-submit modal controls (if present)
      if (target.closest("[data-mix-post-close]") || target.closest("[data-mix-post-overlay]")) {
        this.closePostModal();
        return;
      }
      if (target.closest("[data-mix-post-new]")) {
        this.closePostModal();
        this.highlightBar();
        this.showToast(this.copy.toastNewBox);
        return;
      }
      // Note modal controls (if present)
      if (target.closest("[data-mix-note-close]") || target.closest("[data-mix-note-modal-overlay]")) {
        this.closeNoteModal();
        return;
      }
      if (target.closest("[data-note-preview-open]")) {
        this.openNotePreviewModal();
        return;
      }
      if (target.closest("[data-note-preview-close]") || target.closest("[data-note-preview-overlay]")) {
        this.closeNotePreviewModal();
        return;
      }
      if (target.closest("[data-mix-note-no]")) {
        if (this.pendingSubmit) return;
        this.closeNoteModal();
        this.pendingSubmit = true;
        void this.submitAll();
        return;
      }
      if (target.closest("[data-mix-note-yes]")) {
        var _this$noteTextarea;
        if (this.pendingSubmit) return;
        var note = (((_this$noteTextarea = this.noteTextarea) === null || _this$noteTextarea === void 0 ? void 0 : _this$noteTextarea.value) || "").trim();
        if (!note) {
          var _this$noteTextarea2;
          if (this.noteError) this.noteError.classList.remove("tw:hidden!");
          (_this$noteTextarea2 = this.noteTextarea) === null || _this$noteTextarea2 === void 0 || _this$noteTextarea2.focus();
          return;
        }
        if (this.noteError) this.noteError.classList.add("tw:hidden!");
        this.pendingSubmit = true;
        void this.submitAll(note);
        return;
      }
      // Sidebar list controls
      if (target.closest("[data-mix-list-increment]")) {
        var row = target.closest("[data-variant-id]");
        var variantIdAttr = (row === null || row === void 0 ? void 0 : row.getAttribute("data-variant-id")) || "";
        var variantId = parseInt(variantIdAttr, 10);
        if (!Number.isFinite(variantId)) return;
        this.incrementItem(variantId);
        this.syncCardUI(variantId);
        this.updateUI();
        return;
      }
      if (target.closest("[data-mix-list-decrement]")) {
        var _row = target.closest("[data-variant-id]");
        var _variantIdAttr = (_row === null || _row === void 0 ? void 0 : _row.getAttribute("data-variant-id")) || "";
        var _variantId = parseInt(_variantIdAttr, 10);
        if (!Number.isFinite(_variantId)) return;
        this.decrementItem(_variantId);
        this.syncCardUI(_variantId);
        this.updateUI();
        return;
      }
      if (target.closest("[data-mix-list-remove]")) {
        var _row2 = target.closest("[data-variant-id]");
        var _variantIdAttr2 = (_row2 === null || _row2 === void 0 ? void 0 : _row2.getAttribute("data-variant-id")) || "";
        var _variantId2 = parseInt(_variantIdAttr2, 10);
        if (!Number.isFinite(_variantId2)) return;
        this.removeItem(_variantId2);
        this.syncCardUI(_variantId2);
        this.updateUI();
        return;
      }
      // Product info popout (open modal-box inside the card)
      if (target.closest("[data-mix-open-info]")) {
        var _event$stopImmediateP;
        event.preventDefault();
        // Prevent the theme's global body click handler from immediately hiding the modal we just opened
        event.stopPropagation();
        // Some listeners (jQuery) can be sensitive to immediate propagation; guard for non-standard events
        (_event$stopImmediateP = event.stopImmediatePropagation) === null || _event$stopImmediateP === void 0 || _event$stopImmediateP.call(event);
        var card = target.closest("[data-mix-card]");
        if (!card) return;
        var modal = card.querySelector("modal-box.popup-description");
        if (!modal) return;
        // Prevent theme-level body click handler from closing immediately when interacting inside the modal content
        var content = modal.querySelector(".popup-description__content");
        if (content && !content.hasAttribute("data-mix-stop-propagation")) {
          content.setAttribute("data-mix-stop-propagation", "true");
          content.addEventListener("click", function (e) {
            return e.stopPropagation();
          });
        }
        // Close modal (and restore scroll) when clicking on the backdrop outside the content
        if (!modal.hasAttribute("data-mix-outside-close")) {
          modal.setAttribute("data-mix-outside-close", "true");
          modal.addEventListener("click", function (e) {
            if (content && !content.contains(e.target)) {
              if (typeof modal.hide === "function") {
                modal.hide();
              }
            }
          });
        }
        // Show via the theme's modal-box web component API (if present)
        modal.style.display = "block";
        if (typeof modal.show === "function") {
          modal.show();
        }
        return;
      }
      if (target.closest("[data-mix-submit]")) {
        this.beginSubmitFlow();
        return;
      }
      if (target.closest("[data-mix-add]")) {
        var _card = target.closest("[data-mix-card]");
        if (!_card) return;
        var _variantId3 = this.getVariantIdFromCard(_card);
        var title = _card.getAttribute("data-title") || "Item";
        if (_variantId3 == null) return;
        this.addItem(_variantId3, title);
        this.syncCardUI(_variantId3);
        this.updateUI();
        return;
      }
      if (target.closest("[data-mix-increment]")) {
        var _card2 = target.closest("[data-mix-card]");
        if (!_card2) return;
        var _variantId4 = this.getVariantIdFromCard(_card2);
        if (_variantId4 == null) return;
        this.incrementItem(_variantId4);
        this.syncCardUI(_variantId4);
        this.updateUI();
        return;
      }
      if (target.closest("[data-mix-decrement]")) {
        var _card3 = target.closest("[data-mix-card]");
        if (!_card3) return;
        var _variantId5 = this.getVariantIdFromCard(_card3);
        if (_variantId5 == null) return;
        this.decrementItem(_variantId5);
        this.syncCardUI(_variantId5);
        this.updateUI();
        return;
      }
      if (target.closest("[data-mix-remove]")) {
        var li = target.closest("[data-variant-id]");
        var _variantIdAttr3 = li === null || li === void 0 ? void 0 : li.getAttribute("data-variant-id");
        var _variantId6 = _variantIdAttr3 ? parseInt(_variantIdAttr3, 10) : NaN;
        if (!Number.isFinite(_variantId6)) return;
        this.removeItem(_variantId6);
        this.syncCardUI(_variantId6);
        this.updateUI();
        return;
      }
    }
    // Intercept cart icon clicks to guide user to add the box first
  }, {
    key: "handleGlobalClicks",
    value: function handleGlobalClicks(e) {
      var t = e.target;
      if (!t) return;
      // Find anchor/button that opens cart or links to cart
      var cartToggle = t.closest('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]');
      var cartLink = t.closest('a[href="/cart"]');
      if (!cartToggle && !cartLink) return;
      if (this.items.size === 0) return;
      // If user has pending selection, suggest adding to cart via CTA instead
      e.preventDefault();
      this.highlightBar();
      this.showToast(this.copy.toastCartFirst);
    }
  }, {
    key: "readCopy",
    value: function readCopy() {
      var _this2 = this;
      var attr = function attr(name) {
        return _this2.getAttribute(name);
      };
      return {
        submitBase: attr("data-mix-submit-base") || this.copy.submitBase,
        submitReady: attr("data-mix-submit-ready") || attr("data-mix-submit-base") || this.copy.submitReady,
        submitNeedMoreOne: attr("data-mix-submit-need-more-one") || this.copy.submitNeedMoreOne,
        submitNeedMoreOther: attr("data-mix-submit-need-more-other") || this.copy.submitNeedMoreOther,
        toastCartFirst: attr("data-mix-toast-cart-first") || this.copy.toastCartFirst,
        toastNewBox: attr("data-mix-toast-new-box") || this.copy.toastNewBox,
        toastEditBox: attr("data-mix-toast-edit-box") || this.copy.toastEditBox,
        toastMaxCookies: attr("data-mix-toast-max-cookies") || this.copy.toastMaxCookies,
        sidebarEmptyHint: attr("data-mix-sidebar-empty-hint") || this.copy.sidebarEmptyHint,
        sidebarRemove: attr("data-mix-sidebar-remove") || this.copy.sidebarRemove,
        sidebarPriceLabel: attr("data-mix-sidebar-price-label") || this.copy.sidebarPriceLabel,
        ariaIncrease: attr("data-mix-aria-increase") || this.copy.ariaIncrease,
        ariaDecrease: attr("data-mix-aria-decrease") || this.copy.ariaDecrease
      };
    }
  }, {
    key: "interpolateCopy",
    value: function interpolateCopy(template, vars) {
      return template.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (_m, key) {
        var v = vars[key];
        return v == null ? "" : String(v);
      });
    }
  }, {
    key: "readParentVariantIdByAttr",
    value: function readParentVariantIdByAttr(attr) {
      var raw = (this.getAttribute(attr) || "").trim();
      if (!raw) return null;
      var n = parseInt(raw, 10);
      return Number.isFinite(n) && n > 0 ? n : null;
    }
  }, {
    key: "getActiveParentVariantId",
    value: function getActiveParentVariantId(total) {
      return total >= 5 ? this.parentVariantId8 : this.parentVariantId4;
    }
  }, {
    key: "newGroupId",
    value: function newGroupId() {
      if (window.crypto && typeof crypto.randomUUID === "function") return crypto.randomUUID();
      return "mix_".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 10));
    }
  }, {
    key: "readNoteEnabled",
    value: function readNoteEnabled() {
      var raw = (this.getAttribute("data-mix-note-enabled") || "").trim();
      // Shopify liquid renders "true"/"false"
      return raw === "true" || raw === "1" || raw === "yes";
    }
  }, {
    key: "readNoteVariantId",
    value: function readNoteVariantId() {
      var raw = (this.getAttribute("data-mix-note-variant-id") || "").trim();
      if (!raw) return null;
      var n = parseInt(raw, 10);
      return Number.isFinite(n) && n > 0 ? n : null;
    }
  }, {
    key: "detectCurrency",
    value: function detectCurrency() {
      // Try to detect currency from Shopify global object
      try {
        var _shopify$currency;
        var shopify = window.Shopify;
        if (shopify !== null && shopify !== void 0 && (_shopify$currency = shopify.currency) !== null && _shopify$currency !== void 0 && _shopify$currency.active) {
          this.currencyCode = shopify.currency.active;
        }
      } catch (_unused) {
        // Fallback: try to read from meta tag or page content
      }
      // Map common currencies to their locales for proper formatting
      var currencyLocaleMap = {
        DKK: "da-DK",
        EUR: "da-DK",
        USD: "en-US",
        GBP: "en-GB",
        SEK: "sv-SE",
        NOK: "nb-NO"
      };
      this.currencyLocale = currencyLocaleMap[this.currencyCode] || "da-DK";
    }
  }, {
    key: "openNoteModal",
    value: function openNoteModal() {
      var _this3 = this;
      if (!this.noteModal) return;
      this.noteModal.classList.remove("tw:hidden!");
      this.noteModal.classList.add("tw:flex!");
      this.noteModal.setAttribute("aria-hidden", "false");
      // clear previous error
      if (this.noteError) this.noteError.classList.add("tw:hidden!");
      // Focus textarea
      window.setTimeout(function () {
        var _this3$noteTextarea;
        return (_this3$noteTextarea = _this3.noteTextarea) === null || _this3$noteTextarea === void 0 ? void 0 : _this3$noteTextarea.focus();
      }, 50);
    }
  }, {
    key: "closeNoteModal",
    value: function closeNoteModal() {
      if (!this.noteModal) return;
      this.noteModal.classList.add("tw:hidden!");
      this.noteModal.classList.remove("tw:flex!");
      this.noteModal.setAttribute("aria-hidden", "true");
      if (this.noteError) this.noteError.classList.add("tw:hidden!");
    }
  }, {
    key: "openNotePreviewModal",
    value: function openNotePreviewModal() {
      if (!this.notePreviewModal) return;
      this.notePreviewModal.classList.remove("tw:hidden!");
      this.notePreviewModal.classList.add("tw:flex!");
      this.notePreviewModal.setAttribute("aria-hidden", "false");
    }
  }, {
    key: "closeNotePreviewModal",
    value: function closeNotePreviewModal() {
      if (!this.notePreviewModal) return;
      this.notePreviewModal.classList.add("tw:hidden!");
      this.notePreviewModal.classList.remove("tw:flex!");
      this.notePreviewModal.setAttribute("aria-hidden", "true");
    }
  }, {
    key: "beginSubmitFlow",
    value: function beginSubmitFlow() {
      if (this.pendingSubmit) return;
      var total = this.getTotalQuantity();
      if (!this.isSelectionValid(total)) {
        this.updateUI();
        return;
      }
      if (this.items.size === 0) return;
      // If note feature is enabled and configured, show the 2-step modal.
      if (this.noteEnabled && this.noteVariantId && this.noteModal) {
        this.openNoteModal();
        return;
      }
      // Otherwise submit directly
      this.pendingSubmit = true;
      void this.submitAll();
    }
  }, {
    key: "restoreEditFromSession",
    value: function restoreEditFromSession() {
      var _this4 = this;
      try {
        var _window$sessionStorag;
        var raw = (_window$sessionStorag = window.sessionStorage) === null || _window$sessionStorag === void 0 ? void 0 : _window$sessionStorag.getItem("edition_mix_edit");
        if (!raw) return;
        window.sessionStorage.removeItem("edition_mix_edit");
        var parsed = JSON.parse(raw);
        var items = Array.isArray(parsed === null || parsed === void 0 ? void 0 : parsed.items) ? parsed.items : [];
        var noteText = typeof (parsed === null || parsed === void 0 ? void 0 : parsed.noteText) === "string" ? parsed.noteText : "";
        var removeKeys = Array.isArray(parsed === null || parsed === void 0 ? void 0 : parsed.removeKeys) ? parsed.removeKeys : [];
        if (items.length === 0) return;
        this.editRemoveKeys = removeKeys.filter(function (k) {
          return typeof k === "string" && k.length > 0;
        });
        this.items.clear();
        // Reset card UI first so we don't leave stale states
        this.resetAllCards();
        items.forEach(function (it) {
          var id = Number(it === null || it === void 0 ? void 0 : it.id);
          var quantity = Number(it === null || it === void 0 ? void 0 : it.quantity);
          if (!Number.isFinite(id) || id <= 0) return;
          if (!Number.isFinite(quantity) || quantity <= 0) return;
          var card = _this4.querySelector("[data-mix-card][data-variant-id=\"".concat(id, "\"]"));
          var title = (card === null || card === void 0 ? void 0 : card.getAttribute("data-title")) || "Item";
          _this4.items.set(id, {
            id: id,
            title: title,
            quantity: quantity
          });
        });
        Array.from(this.items.keys()).forEach(function (variantId) {
          return _this4.syncCardUI(variantId);
        });
        if (this.noteTextarea) {
          this.noteTextarea.value = noteText;
        }
        this.highlightBar();
        this.showToast(this.copy.toastEditBox);
      } catch (_unused2) {
        // ignore
      }
    }
  }, {
    key: "removeEditLinesIfNeeded",
    value: function () {
      var _removeEditLinesIfNeeded = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _iterator, _step, key, res, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.editRemoveKeys.length) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              // Remove sequentially to avoid spamming the cart endpoint.
              _iterator = _createForOfIteratorHelper(this.editRemoveKeys);
              _context.p = 2;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context.n = 9;
                break;
              }
              key = _step.value;
              _context.p = 4;
              _context.n = 5;
              return fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json"
                },
                body: JSON.stringify({
                  id: key,
                  quantity: 0
                })
              });
            case 5:
              res = _context.v;
              if (!res.ok) {
                _context.n = 6;
                break;
              }
              _context.n = 6;
              return res.json();
            case 6:
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
            case 8:
              _context.n = 3;
              break;
            case 9:
              _context.n = 11;
              break;
            case 10:
              _context.p = 10;
              _t2 = _context.v;
              _iterator.e(_t2);
            case 11:
              _context.p = 11;
              _iterator.f();
              return _context.f(11);
            case 12:
              // Only try once per page session.
              this.editRemoveKeys = [];
            case 13:
              return _context.a(2);
          }
        }, _callee, this, [[4, 7], [2, 10, 11, 12]]);
      }));
      function removeEditLinesIfNeeded() {
        return _removeEditLinesIfNeeded.apply(this, arguments);
      }
      return removeEditLinesIfNeeded;
    }()
  }, {
    key: "getVariantIdFromCard",
    value: function getVariantIdFromCard(card) {
      var idAttr = card.getAttribute("data-variant-id");
      if (!idAttr) return null;
      var id = parseInt(idAttr, 10);
      return Number.isFinite(id) ? id : null;
    }
  }, {
    key: "addItem",
    value: function addItem(variantId, title) {
      if (this.getTotalQuantity() >= this.maxTotal) {
        this.showToast(this.interpolateCopy(this.copy.toastMaxCookies, {
          max: this.maxTotal
        }));
        return;
      }
      var existing = this.items.get(variantId);
      if (existing) {
        existing.quantity += 1;
        this.items.set(variantId, existing);
      } else {
        this.items.set(variantId, {
          id: variantId,
          title: title,
          quantity: 1
        });
      }
    }
  }, {
    key: "incrementItem",
    value: function incrementItem(variantId) {
      if (this.getTotalQuantity() >= this.maxTotal) {
        this.showToast(this.interpolateCopy(this.copy.toastMaxCookies, {
          max: this.maxTotal
        }));
        return;
      }
      var existing = this.items.get(variantId);
      if (!existing) return;
      existing.quantity += 1;
      this.items.set(variantId, existing);
    }
  }, {
    key: "decrementItem",
    value: function decrementItem(variantId) {
      var existing = this.items.get(variantId);
      if (!existing) return;
      if (existing.quantity <= 1) {
        this.items["delete"](variantId);
      } else {
        existing.quantity -= 1;
        this.items.set(variantId, existing);
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(variantId) {
      this.items["delete"](variantId);
    }
  }, {
    key: "getTotalQuantity",
    value: function getTotalQuantity() {
      var total = 0;
      this.items.forEach(function (item) {
        total += item.quantity;
      });
      return total;
    }
  }, {
    key: "isSelectionValid",
    value: function isSelectionValid(total) {
      // Business rule: only allow adding the box when total is exactly min OR max.
      return total === this.minTotal || total === this.maxTotal;
    }
  }, {
    key: "getMissingForNextValid",
    value: function getMissingForNextValid(total) {
      if (total <= 0) return this.minTotal;
      if (total < this.minTotal) return this.minTotal - total;
      if (total > this.minTotal && total < this.maxTotal) return this.maxTotal - total;
      return 0;
    }
  }, {
    key: "updateUI",
    value: function updateUI() {
      var _this5 = this;
      var total = this.getTotalQuantity();
      var isValid = total > 0 && this.isSelectionValid(total);
      var submitBtns = this.submitBtns.length ? this.submitBtns : this.submitBtn ? [this.submitBtn] : [];
      var validationEls = this.validationEls.length ? this.validationEls : this.validationEl ? [this.validationEl] : [];
      var progressEls = this.progressEls.length ? this.progressEls : this.progressEl ? [this.progressEl] : [];
      var progressLabelEls = this.progressLabelEls.length ? this.progressLabelEls : this.progressLabelEl ? [this.progressLabelEl] : [];
      if (submitBtns.length) {
        var readyLabel = this.copy.submitReady || this.copy.submitBase;
        submitBtns.forEach(function (btn) {
          btn.disabled = !isValid;
          btn.classList.toggle("tw:opacity-50", btn.disabled);
          if (isValid) {
            btn.textContent = readyLabel;
            return;
          }
          var missing = _this5.getMissingForNextValid(total);
          var template = missing === 1 ? _this5.copy.submitNeedMoreOne : _this5.copy.submitNeedMoreOther;
          btn.textContent = _this5.interpolateCopy(template, {
            count: missing
          });
        });
        if (isValid && !this.lastIsValid) {
          submitBtns.forEach(function (btn) {
            return btn.classList.add("tw:animate-pulse");
          });
          window.setTimeout(function () {
            return submitBtns.forEach(function (btn) {
              return btn.classList.remove("tw:animate-pulse");
            });
          }, 900);
        }
      }
      validationEls.forEach(function (el) {
        el.style.display = total > 0 && !isValid ? "block" : "none";
      });
      if (progressEls.length) {
        var denom = this.maxTotal;
        var pct = denom > 0 ? Math.min(100, Math.round(total / denom * 100)) : 0;
        progressEls.forEach(function (el) {
          el.style.width = "".concat(pct, "%");
        });
      }
      // Milestone dot (minTotal) on the progress track
      if (this.progressDotEls.length) {
        var _denom = this.maxTotal;
        var dotPct = _denom > 0 ? Math.max(0, Math.min(100, this.minTotal / _denom * 100)) : 0;
        var reached = total >= this.minTotal && total > 0;
        this.progressDotEls.forEach(function (el) {
          el.style.left = "".concat(dotPct, "%");
          el.classList.toggle("is-reached", reached);
        });
      }
      progressLabelEls.forEach(function (el) {
        el.textContent = "".concat(total, "/").concat(_this5.maxTotal);
      });
      // Box preview image (0–4 vs 5–8 cookies)
      this.updateBoxPreviewImages(total);
      // Mobile bar total price
      var totalPriceText = this.getTotalPriceText(total);
      var priceEls = this.totalPriceEls.length ? this.totalPriceEls : [];
      priceEls.forEach(function (el) {
        el.textContent = totalPriceText;
      });
      this.lastIsValid = isValid;
      this.renderSidebarList();
    }
  }, {
    key: "updateBoxPreviewImages",
    value: function updateBoxPreviewImages(total) {
      if (!this.boxImageEls.length) return;
      // Spec: 0-4 => low image, 5-8 => high image
      var useHigh = total >= 5;
      this.boxImageEls.forEach(function (img) {
        var low = (img.getAttribute("data-mix-box-image-low") || "").trim();
        var high = (img.getAttribute("data-mix-box-image-high") || "").trim();
        var desired = useHigh ? high : low;
        if (!desired) return;
        // Only zoom the low image (0–4)
        if (useHigh) {
          img.style.removeProperty("transform");
          img.style.removeProperty("transform-origin");
        } else {
          img.style.setProperty("transform", "scale(1.4)");
          img.style.setProperty("transform-origin", "center");
        }
        var current = (img.getAttribute("src") || "").trim();
        if (current !== desired) img.setAttribute("src", desired);
      });
    }
  }, {
    key: "getTotalPriceText",
    value: function getTotalPriceText(totalQty) {
      // If nothing selected, show 0.00 in the correct currency instead of "—".
      if (totalQty === 0) {
        try {
          return new Intl.NumberFormat(this.currencyLocale, {
            style: "currency",
            currency: this.currencyCode
          }).format(0);
        } catch (_unused4) {
          return "0 ".concat(this.currencyCode);
        }
      }
      return this.formatTotalPrice();
    }
  }, {
    key: "loadBoxImage",
    value: function () {
      var _loadBoxImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _ref, _this$getActiveParent;
        var total, variantId, res, data, featured, src, alt, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!this.boxImageLoaded) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              total = this.getTotalQuantity();
              variantId = (_ref = (_this$getActiveParent = this.getActiveParentVariantId(total)) !== null && _this$getActiveParent !== void 0 ? _this$getActiveParent : this.parentVariantId8) !== null && _ref !== void 0 ? _ref : this.parentVariantId4;
              if (variantId) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _context2.p = 2;
              _context2.n = 3;
              return fetch("/variants/".concat(variantId, ".js"), {
                method: "GET",
                headers: {
                  Accept: "application/json"
                }
              });
            case 3:
              res = _context2.v;
              if (res.ok) {
                _context2.n = 4;
                break;
              }
              return _context2.a(2);
            case 4:
              _context2.n = 5;
              return res.json();
            case 5:
              data = _context2.v;
              featured = data === null || data === void 0 ? void 0 : data.featured_image;
              src = typeof featured === "string" ? featured : typeof (featured === null || featured === void 0 ? void 0 : featured.src) === "string" ? featured.src : typeof (data === null || data === void 0 ? void 0 : data.image) === "string" ? data.image : null;
              if (src) {
                _context2.n = 6;
                break;
              }
              return _context2.a(2);
            case 6:
              alt = typeof (data === null || data === void 0 ? void 0 : data.name) === "string" ? data.name : "";
              this.boxImageLoaded = true;
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t3 = _context2.v;
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 7]]);
      }));
      function loadBoxImage() {
        return _loadBoxImage.apply(this, arguments);
      }
      return loadBoxImage;
    }()
  }, {
    key: "renderSidebarList",
    value: function renderSidebarList() {
      var _this6 = this;
      var hosts = this.listHosts.length ? this.listHosts : this.boxListEl ? [this.boxListEl] : [];
      if (!hosts.length) return;
      var total = this.getTotalQuantity();
      var canAddMore = total < this.maxTotal;
      if (this.items.size === 0) {
        var emptyHtml = "\n        <div class=\"tw:text-sm! tw:text-[var(--color-text-secondary)]! tw:py-2!\">\n          ".concat(this.escapeHtml(this.interpolateCopy(this.copy.sidebarEmptyHint, {
          min: this.minTotal,
          max: this.maxTotal
        })), "\n        </div>\n      ");
        hosts.forEach(function (h) {
          return h.innerHTML = emptyHtml;
        });
        return;
      }
      var rows = Array.from(this.items.values()).sort(function (a, b) {
        return a.title.localeCompare(b.title);
      }).map(function (item) {
        var title = _this6.escapeHtml(item.title);
        var imgSrc = _this6.getCardImageSrc(item.id);
        var imgHtml = imgSrc ? "<img src=\"".concat(_this6.escapeHtml(imgSrc), "\" alt=\"").concat(title, "\" class=\"tw:h-12! tw:w-12! tw:rounded-lg! tw:object-cover! tw:flex-none!\" loading=\"lazy\">") : "<div class=\"tw:h-12! tw:w-12! tw:rounded-lg! tw:bg-[var(--color-borders-cards)]/40! tw:flex-none!\"></div>";
        var incDisabled = !canAddMore ? "disabled" : "";
        var incClasses = !canAddMore ? "tw:opacity-50 tw:cursor-not-allowed" : "";
        return "\n          <div\n            class=\"tw:flex! tw:items-center! tw:justify-between! tw:gap-3! tw:py-2! tw:border-b! tw:border-[rgba(148,163,184,0.25)]!\"\n            data-variant-id=\"".concat(item.id, "\">\n            <div class=\"tw:flex! tw:items-center! tw:gap-3! tw:min-w-0!\">\n              ").concat(imgHtml, "\n              <div class=\"tw:flex! tw:flex-col! tw:min-w-0!\">\n                <div class=\"tw:text-sm! tw:font-medium! tw:truncate!\">").concat(title, "</div>\n                <button type=\"button\" class=\"tw:text-xs! tw:underline! tw:text-[var(--color-text-secondary)]! tw:text-left!\" data-mix-list-remove>\n                  ").concat(_this6.escapeHtml(_this6.copy.sidebarRemove), "\n                </button>\n              </div>\n            </div>\n            <div class=\"tw:flex! tw:items-center! tw:gap-2!\">\n              <button type=\"button\" class=\"tw:h-8! tw:w-8! tw:rounded-full! tw:border! tw:border-[var(--color-borders-cards)]!\" data-mix-list-decrement aria-label=\"").concat(_this6.escapeHtml(_this6.copy.ariaDecrease), "\">\n                \u2212\n              </button>\n              <div class=\"tw:w-6! tw:text-center! tw:text-sm!\">").concat(item.quantity, "</div>\n              <button type=\"button\" class=\"tw:h-8! tw:w-8! tw:rounded-full! tw:border! tw:border-[var(--color-borders-cards)]! ").concat(incClasses, "\" data-mix-list-increment aria-label=\"").concat(_this6.escapeHtml(_this6.copy.ariaIncrease), "\" ").concat(incDisabled, ">\n                +\n              </button>\n            </div>\n          </div>\n        ");
      }).join("");
      var totalPriceText = this.formatTotalPrice();
      var desktopHtml = "\n      <div class=\"tw:flex! tw:flex-col!\">\n        ".concat(rows, "\n        <div class=\"tw:flex! tw:items-center! tw:justify-between! tw:pt-3!\">\n          <div class=\"tw:text-sm! tw:font-semibold!\">").concat(this.escapeHtml(this.copy.sidebarPriceLabel), "</div>\n          <div class=\"tw:text-sm!\">").concat(this.escapeHtml(totalPriceText), "</div>\n        </div>\n      </div>\n    ");
      var mobileHtml = "\n      <div class=\"tw:flex! tw:flex-col!\">\n        ".concat(rows, "\n      </div>\n    ");
      hosts.forEach(function (h) {
        var isMobileHost = h.hasAttribute("data-mix-mobile-list") || Boolean(h.closest("[data-mix-mobile-drawer]"));
        h.innerHTML = isMobileHost ? mobileHtml : desktopHtml;
      });
    }
  }, {
    key: "formatTotalPrice",
    value: function formatTotalPrice() {
      var _this7 = this;
      var totalCents = 0;
      var hasAny = false;
      this.items.forEach(function (item) {
        var unitCents = _this7.getCardUnitPriceCents(item.id);
        if (unitCents == null) return;
        hasAny = true;
        totalCents += unitCents * item.quantity;
      });
      if (!hasAny) return "—";
      // Format with the detected currency and locale
      try {
        return new Intl.NumberFormat(this.currencyLocale, {
          style: "currency",
          currency: this.currencyCode
        }).format(totalCents / 100);
      } catch (_unused6) {
        // Simple fallback if Intl fails
        var amount = (totalCents / 100).toFixed(2).replace(".", ",");
        return "".concat(amount, " ").concat(this.currencyCode);
      }
    }
  }, {
    key: "getCardUnitPriceCents",
    value: function getCardUnitPriceCents(variantId) {
      var card = this.querySelector("[data-mix-card][data-variant-id=\"".concat(variantId, "\"]"));
      if (!card) return null;
      // Try common selectors used by Shopify themes
      var priceEl = card.querySelector(".product-item__price") || card.querySelector(".price") || card.querySelector(".money") || null;
      var raw = ((priceEl === null || priceEl === void 0 ? void 0 : priceEl.textContent) || "").trim();
      if (!raw) return null;
      // Parse something like "25,00 kr" or "DKK 25.00".
      // We only need a best-effort number for the sidebar.
      var cleaned = raw.replace(/\s+/g, " ").replace(/[^0-9.,-]/g, "").trim();
      if (!cleaned) return null;
      // Danish format commonly uses comma decimals.
      var normalized = cleaned.includes(",") && !cleaned.includes(".") ? cleaned.replace(",", ".") : cleaned;
      var num = Number.parseFloat(normalized);
      if (!Number.isFinite(num)) return null;
      return Math.round(num * 100);
    }
  }, {
    key: "getCardImageSrc",
    value: function getCardImageSrc(variantId) {
      var card = this.querySelector("[data-mix-card][data-variant-id=\"".concat(variantId, "\"]"));
      if (!card) return null;
      var img = card.querySelector("img.img, img");
      if (!img) return null;
      var src = (img.currentSrc || img.src || "").trim();
      return src || null;
    }
  }, {
    key: "syncCardUI",
    value: function syncCardUI(variantId) {
      var card = this.querySelector("[data-mix-card][data-variant-id=\"".concat(variantId, "\"]"));
      if (!card) return;
      var addBtn = card.querySelector("[data-mix-add]");
      var qtyControls = card.querySelector("[data-mix-qty-controls]");
      var qtyEl = card.querySelector("[data-mix-qty]");
      var item = this.items.get(variantId);
      if (item) {
        if (addBtn) addBtn.classList.add("tw:hidden!");
        if (qtyControls) {
          qtyControls.classList.remove("tw:hidden!");
          qtyControls.classList.add("tw:flex!");
        }
        if (qtyEl) qtyEl.textContent = String(item.quantity);
      } else {
        if (addBtn) addBtn.classList.remove("tw:hidden!");
        if (qtyControls) {
          qtyControls.classList.add("tw:hidden!");
          qtyControls.classList.remove("tw:flex!");
        }
        if (qtyEl) qtyEl.textContent = "1";
      }
    }
  }, {
    key: "updateMobileBarOffset",
    value: function updateMobileBarOffset() {
      if (!this.mobileDrawer) return;
      var barH = this.mobileBar ? Math.max(0, Math.round(this.mobileBar.getBoundingClientRect().height)) : 0;
      var openH = this.mobileOpenBtn ? Math.max(0, Math.round(this.mobileOpenBtn.getBoundingClientRect().height)) : 0;
      // We want the drawer to appear to slide from under the bar and stop slightly lower,
      // overlapping the opener tab instead of stopping above it.
      var effectiveOffset = Math.max(0, barH - openH);
      this.mobileDrawer.style.setProperty("--mix-mobile-bar-h", "".concat(effectiveOffset, "px"));
    }
  }, {
    key: "openMobileDrawer",
    value: function openMobileDrawer() {
      var _this$mobileOverlay,
        _this$mobileSheet,
        _this8 = this;
      if (!this.mobileDrawer) return;
      // Ensure we have the box image loaded when user interacts on mobile.
      void this.loadBoxImage();
      this.mobileDrawer.classList.remove("tw:hidden!");
      this.mobileDrawer.setAttribute("aria-hidden", "false");
      // Mark state so Liquid/CSS can adjust layering (e.g. hide opener tab)
      this.setAttribute("data-mix-drawer-open", "true");
      // Offset the drawer so it slides up behind (not over) the fixed bottom bar.
      this.updateMobileBarOffset();
      // Start from hidden state and then animate in.
      (_this$mobileOverlay = this.mobileOverlay) === null || _this$mobileOverlay === void 0 || _this$mobileOverlay.classList.add("tw:opacity-0!");
      (_this$mobileSheet = this.mobileSheet) === null || _this$mobileSheet === void 0 || _this$mobileSheet.classList.add("tw:translate-y-full");
      window.requestAnimationFrame(function () {
        var _this8$mobileOverlay, _this8$mobileSheet;
        (_this8$mobileOverlay = _this8.mobileOverlay) === null || _this8$mobileOverlay === void 0 || _this8$mobileOverlay.classList.remove("tw:opacity-0!");
        (_this8$mobileSheet = _this8.mobileSheet) === null || _this8$mobileSheet === void 0 || _this8$mobileSheet.classList.remove("tw:translate-y-full");
      });
    }
  }, {
    key: "closeMobileDrawer",
    value: function closeMobileDrawer() {
      var _this$mobileOverlay2,
        _this$mobileSheet2,
        _this9 = this;
      if (!this.mobileDrawer) return;
      // Animate out
      (_this$mobileOverlay2 = this.mobileOverlay) === null || _this$mobileOverlay2 === void 0 || _this$mobileOverlay2.classList.add("tw:opacity-0!");
      (_this$mobileSheet2 = this.mobileSheet) === null || _this$mobileSheet2 === void 0 || _this$mobileSheet2.classList.add("tw:translate-y-full");
      var finish = function finish() {
        var _this9$mobileDrawer, _this9$mobileDrawer2;
        (_this9$mobileDrawer = _this9.mobileDrawer) === null || _this9$mobileDrawer === void 0 || _this9$mobileDrawer.classList.add("tw:hidden!");
        (_this9$mobileDrawer2 = _this9.mobileDrawer) === null || _this9$mobileDrawer2 === void 0 || _this9$mobileDrawer2.setAttribute("aria-hidden", "true");
        _this9.removeAttribute("data-mix-drawer-open");
      };
      var sheet = this.mobileSheet;
      if (!sheet) {
        finish();
        return;
      }
      var _onEnd = function onEnd(e) {
        if (e.target !== sheet) return;
        sheet.removeEventListener("transitionend", _onEnd);
        finish();
      };
      sheet.addEventListener("transitionend", _onEnd);
      window.setTimeout(function () {
        sheet.removeEventListener("transitionend", _onEnd);
        if (_this9.mobileDrawer && !_this9.mobileDrawer.classList.contains("tw:hidden!")) finish();
      }, 350);
    }
  }, {
    key: "submitAll",
    value: function () {
      var _submitAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(noteText) {
        var total, editUrl, itemsPayload, parentVariantId, groupId, boxProps, note, perVariant, res, details, err, _t4, _t5;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              total = this.getTotalQuantity();
              if (this.isSelectionValid(total)) {
                _context3.n = 1;
                break;
              }
              this.updateUI();
              this.pendingSubmit = false;
              return _context3.a(2);
            case 1:
              if (!(this.items.size === 0)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return this.removeEditLinesIfNeeded();
            case 3:
              editUrl = "".concat(window.location.pathname).concat(window.location.search || "");
              itemsPayload = [];
              parentVariantId = this.getActiveParentVariantId(total);
              if (parentVariantId) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2);
            case 4:
              // One big box per submit/edit.
              // Still use a unique _mix_group so separate submits don't merge line items in Shopify.
              groupId = this.newGroupId();
              boxProps = {
                _mix_group: groupId,
                _mix_type: "box",
                _mix_edit_url: editUrl
              };
              itemsPayload.push({
                id: parentVariantId,
                quantity: 1,
                properties: boxProps
              });
              // Optional gift note (one per box)
              note = (noteText || "").trim();
              if (note && this.noteEnabled && this.noteVariantId) {
                itemsPayload.push({
                  id: this.noteVariantId,
                  quantity: 1,
                  parent_id: parentVariantId,
                  properties: {
                    _mix_group: groupId,
                    _mix_type: "note",
                    _mix_edit_url: editUrl,
                    _mix_parent_variant_id: String(parentVariantId),
                    gift_note: note,
                    _is_gift_note_product: "true",
                    _gift_note_for_product: "Box"
                  }
                });
              }
              perVariant = new Map();
              Array.from(this.items.values()).forEach(function (i) {
                perVariant.set(i.id, (perVariant.get(i.id) || 0) + i.quantity);
              });
              Array.from(perVariant.entries()).forEach(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                  variantId = _ref3[0],
                  qty = _ref3[1];
                var props = {
                  _mix_group: groupId,
                  _mix_type: "cookie",
                  _mix_edit_url: editUrl,
                  _mix_parent_variant_id: String(parentVariantId)
                };
                itemsPayload.push({
                  id: variantId,
                  quantity: qty,
                  parent_id: parentVariantId,
                  properties: props
                });
              });
              _context3.p = 5;
              _context3.n = 6;
              return fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  items: itemsPayload
                })
              });
            case 6:
              res = _context3.v;
              if (res.ok) {
                _context3.n = 11;
                break;
              }
              details = "";
              _context3.p = 7;
              _context3.n = 8;
              return res.json();
            case 8:
              err = _context3.v;
              details = err !== null && err !== void 0 && err.description ? ": ".concat(err.description) : "";
              _context3.n = 10;
              break;
            case 9:
              _context3.p = 9;
              _t4 = _context3.v;
            case 10:
              throw new Error("Failed to add items to cart".concat(details));
            case 11:
              // Success: clear and reset
              this.items.clear();
              this.resetAllCards();
              this.updateUI();
              this.closeNoteModal();
              this.pendingSubmit = false;
              // Post-submit choice: checkout vs start new box
              this.openPostModal();
              _context3.n = 13;
              break;
            case 12:
              _context3.p = 12;
              _t5 = _context3.v;
              // eslint-disable-next-line no-console
              console.error(_t5);
              this.pendingSubmit = false;
            case 13:
              return _context3.a(2);
          }
        }, _callee3, this, [[7, 9], [5, 12]]);
      }));
      function submitAll(_x) {
        return _submitAll.apply(this, arguments);
      }
      return submitAll;
    }()
  }, {
    key: "openPostModal",
    value: function openPostModal() {
      if (!this.postModal) {
        // Fallback if the modal isn't present in Liquid
        window.location.href = "/cart";
        return;
      }
      this.postModal.classList.remove("tw:hidden!");
      this.postModal.classList.add("tw:flex!");
      this.postModal.setAttribute("aria-hidden", "false");
      // Ensure cart link is present even if theme overrides
      if (this.postCheckoutBtn) {
        this.postCheckoutBtn.setAttribute("href", "/cart");
      }
    }
  }, {
    key: "closePostModal",
    value: function closePostModal() {
      if (!this.postModal) return;
      this.postModal.classList.add("tw:hidden!");
      this.postModal.classList.remove("tw:flex!");
      this.postModal.setAttribute("aria-hidden", "true");
    }
  }, {
    key: "resetAllCards",
    value: function resetAllCards() {
      var cards = this.querySelectorAll("[data-mix-card]");
      cards.forEach(function (card) {
        var addBtn = card.querySelector("[data-mix-add]");
        var qtyControls = card.querySelector("[data-mix-qty-controls]");
        var qtyEl = card.querySelector("[data-mix-qty]");
        if (addBtn) addBtn.classList.remove("tw:hidden!", "tw:hidden");
        if (qtyControls) {
          qtyControls.classList.add("tw:hidden!");
          qtyControls.classList.remove("tw:flex!");
        }
        if (qtyEl) qtyEl.textContent = "1";
      });
    }
  }, {
    key: "escapeHtml",
    value: function escapeHtml(text) {
      var map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      };
      return text.replace(/[&<>"']/g, function (m) {
        return map[m];
      });
    }
  }, {
    key: "highlightBar",
    value: function highlightBar() {
      var bars = this.bars.length ? this.bars : this.bar ? [this.bar] : [];
      if (!bars.length) return;
      bars.forEach(function (el) {
        return el.classList.add("tw:animate-pulse");
      });
      window.setTimeout(function () {
        bars.forEach(function (el) {
          return el.classList.remove("tw:animate-pulse");
        });
      }, 800);
    }
  }, {
    key: "showToast",
    value: function showToast(message) {
      var toasts = this.toastEls.length ? this.toastEls : this.toastEl ? [this.toastEl] : [];
      if (!toasts.length) return;
      toasts.forEach(function (t) {
        t.textContent = message;
        t.classList.remove("tw:hidden");
        t.classList.add("tw:text-xs", "tw:text-[var(--color-text-secondary)]");
      });
      window.setTimeout(function () {
        toasts.forEach(function (t) {
          return t.classList.add("tw:hidden");
        });
      }, 1800);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/CollectionProductMix/mix-cart-edit.ts"
/*!****************************************************************************!*\
  !*** ./resources/scripts/components/CollectionProductMix/mix-cart-edit.ts ***!
  \****************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initMixCartEdit)
/* harmony export */ });
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var STORAGE_KEY = "edition_mix_edit";
function removeLineByKey(_x) {
  return _removeLineByKey.apply(this, arguments);
}
function _removeLineByKey() {
  _removeLineByKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(key) {
    var res;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({
              id: key,
              quantity: 0
            })
          });
        case 1:
          res = _context2.v;
          if (res.ok) {
            _context2.n = 2;
            break;
          }
          throw new Error("Failed to remove cart item");
        case 2:
          _context2.n = 3;
          return res.json();
        case 3:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _removeLineByKey.apply(this, arguments);
}
function initMixCartEdit() {
  // Idempotent init (avoid double-binding in case theme rehydrates)
  if (window.__mixCartEditBound) return;
  window.__mixCartEditBound = true;
  document.addEventListener("click", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var btn, editUrl, itemsRaw, keysRaw, boxName, noteText, items, keys, _window$sessionStorag, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            btn = e.target instanceof Element ? e.target.closest("[data-mix-edit]") : null;
            if (btn) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            e.preventDefault();
            editUrl = btn.getAttribute("data-mix-edit-url") || "/collections/bland-selv-cookies";
            itemsRaw = btn.getAttribute("data-mix-edit-items") || "[]";
            keysRaw = btn.getAttribute("data-mix-remove-keys") || "[]";
            boxName = btn.getAttribute("data-mix-box-name") || "";
            noteText = btn.getAttribute("data-mix-note-text") || "";
            items = [];
            keys = [];
            _context.p = 2;
            items = JSON.parse(itemsRaw) || [];
            keys = JSON.parse(keysRaw) || [];
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            window.location.href = editUrl;
            return _context.a(2);
          case 4:
            try {
              // Persist both the items we want to restore AND the keys to remove.
              // We also remove immediately below, but some environments (mobile / slow networks) can
              // fail intermittently; removal is re-attempted on submit from the collection page.
              (_window$sessionStorag = window.sessionStorage) === null || _window$sessionStorag === void 0 || _window$sessionStorag.setItem(STORAGE_KEY, JSON.stringify({
                items: items,
                boxName: boxName,
                noteText: noteText,
                removeKeys: keys
              }));
            } catch (_unused2) {
              // ignore storage failures
            }
            _context.p = 5;
            _context.n = 6;
            return Promise.all(keys.map(function (k) {
              return removeLineByKey(k);
            }));
          case 6:
            _context.n = 8;
            break;
          case 7:
            _context.p = 7;
            _t2 = _context.v;
            // eslint-disable-next-line no-console
            console.error(_t2);
          case 8:
            window.location.href = editUrl;
          case 9:
            return _context.a(2);
        }
      }, _callee, null, [[5, 7], [2, 3]]);
    }));
    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }(), true);
}

/***/ },

/***/ "./resources/scripts/components/OrderNote/OrderNote.ts"
/*!*************************************************************!*\
  !*** ./resources/scripts/components/OrderNote/OrderNote.ts ***!
  \*************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ OrderNote)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var OrderNote = /*#__PURE__*/function (_HTMLElement) {
  function OrderNote() {
    var _this;
    _classCallCheck(this, OrderNote);
    _this = _callSuper(this, OrderNote);
    _defineProperty(_this, "button", null);
    _defineProperty(_this, "contentWrapper", null);
    _defineProperty(_this, "textarea", null);
    _defineProperty(_this, "hiddenInput", null);
    _defineProperty(_this, "isExpanded", false);
    _defineProperty(_this, "priceIndicator", null);
    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleTextChange = _this.handleTextChange.bind(_this);
    _this.addGiftNoteProduct = _this.addGiftNoteProduct.bind(_this);
    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
    return _this;
  }
  _inherits(OrderNote, _HTMLElement);
  return _createClass(OrderNote, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.button = this.querySelector("[data-note-button]");
      this.contentWrapper = this.querySelector("[data-note-content]");
      this.textarea = this.querySelector("[data-note-textarea]");
      this.hiddenInput = this.querySelector("[data-note-product]");
      this.priceIndicator = this.querySelector("[data-price-indicator]");
      if (!this.button || !this.contentWrapper || !this.textarea) {
        console.error("OrderNote: Required elements not found");
        return;
      }
      this.addEventListeners();
      this.initializeState();
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      if (this.button) {
        this.button.addEventListener("click", this.handleToggle);
      }
      if (this.textarea) {
        this.textarea.addEventListener("input", this.handleTextChange);
      }
      // Listen for form submissions to add the gift note product
      var form = this.closest("form");
      if (form) {
        form.addEventListener("submit", this.handleFormSubmit);
      }
    }
  }, {
    key: "initializeState",
    value: function initializeState() {
      // Check if there's already a note in the textarea
      if (this.textarea && this.textarea.value.trim() !== "") {
        this.expand();
      } else {
        this.collapse();
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      if (this.isExpanded) {
        this.collapse();
      } else {
        this.expand();
      }
    }
  }, {
    key: "expand",
    value: function expand() {
      var _this2 = this;
      if (!this.contentWrapper || !this.button) return;
      this.isExpanded = true;
      this.contentWrapper.style.maxHeight = "".concat(this.contentWrapper.scrollHeight, "px");
      this.contentWrapper.style.opacity = "1";
      this.contentWrapper.style.marginTop = "1rem";
      this.button.setAttribute("aria-expanded", "true");
      this.button.classList.add("note-active");
      // Update price indicator
      if (this.priceIndicator) {
        this.priceIndicator.classList.add("active");
      }
      // Focus on textarea after animation
      setTimeout(function () {
        if (_this2.textarea) {
          _this2.textarea.focus();
        }
      }, 300);
    }
  }, {
    key: "collapse",
    value: function collapse() {
      if (!this.contentWrapper || !this.button) return;
      // Clear textarea when collapsing
      if (this.textarea) {
        this.textarea.value = "";
      }
      this.isExpanded = false;
      this.contentWrapper.style.maxHeight = "0";
      this.contentWrapper.style.opacity = "0";
      this.contentWrapper.style.marginTop = "0";
      this.button.setAttribute("aria-expanded", "false");
      this.button.classList.remove("note-active");
      // Update price indicator
      if (this.priceIndicator) {
        this.priceIndicator.classList.remove("active");
      }
    }
  }, {
    key: "handleTextChange",
    value: function handleTextChange() {
      // Text changes handled, product added on submit
    }
  }, {
    key: "handleFormSubmit",
    value: function () {
      var _handleFormSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var _document$querySelect, _this$hiddenInput, giftNote, form, productIdInput, mainProductId, productTitle, giftNoteProductId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(this.isExpanded && this.textarea && this.textarea.value.trim() !== "")) {
                _context.n = 3;
                break;
              }
              event.preventDefault();
              giftNote = this.textarea.value.trim();
              form = event.target; // Get the main product ID from the form
              productIdInput = form.querySelector('input[name="id"]');
              mainProductId = productIdInput === null || productIdInput === void 0 ? void 0 : productIdInput.value; // Get the product name from the page
              productTitle = ((_document$querySelect = document.querySelector(".product__title")) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.textContent) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.trim()) || "Unknown Product"; // Get the gift note product ID from hidden input
              giftNoteProductId = (_this$hiddenInput = this.hiddenInput) === null || _this$hiddenInput === void 0 ? void 0 : _this$hiddenInput.value;
              if (!(!form || !mainProductId || !giftNoteProductId)) {
                _context.n = 1;
                break;
              }
              console.error("Form, main product ID, or gift note product ID not found");
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.addGiftNoteProduct(giftNoteProductId, giftNote, productTitle);
            case 2:
              // Then submit the main form
              form.submit();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleFormSubmit(_x) {
        return _handleFormSubmit.apply(this, arguments);
      }
      return handleFormSubmit;
    }()
  }, {
    key: "addGiftNoteProduct",
    value: function () {
      var _addGiftNoteProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(giftNoteProductId, note, productName) {
        var formData, response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              formData = {
                items: [{
                  id: giftNoteProductId,
                  quantity: 1,
                  properties: {
                    gift_note: note,
                    _is_gift_note_product: "true",
                    _gift_note_for_product: productName
                  }
                }]
              };
              _context2.n = 1;
              return fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
              });
            case 1:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 2;
                break;
              }
              throw new Error("Failed to add gift note product to cart");
            case 2:
              console.log("Gift note product added to cart");
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.error("Error adding gift note product:", _t);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 3]]);
      }));
      function addGiftNoteProduct(_x2, _x3, _x4) {
        return _addGiftNoteProduct.apply(this, arguments);
      }
      return addGiftNoteProduct;
    }()
  }, {
    key: "addPropertyInputs",
    value: function addPropertyInputs(form, note, productId) {
      // This method is no longer used but kept for backwards compatibility
      console.log("addPropertyInputs is deprecated");
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener("click", this.handleToggle);
      }
      if (this.textarea) {
        this.textarea.removeEventListener("input", this.handleTextChange);
      }
      var form = this.closest("form");
      if (form) {
        form.removeEventListener("submit", this.handleFormSubmit);
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/styles/app.css"
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkcookiesbyejvinds"] = self["webpackChunkcookiesbyejvinds"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;